import { library } from '@fortawesome/fontawesome-svg-core'

import { faCirclePlus as fatCirclePlus } from '@fortawesome/pro-thin-svg-icons/faCirclePlus'

library.add(fatCirclePlus)

import { faArrowRotateLeft as farArrowRotateLeft } from '@fortawesome/pro-regular-svg-icons/faArrowRotateLeft'
import { faPlus as farPlus } from '@fortawesome/pro-regular-svg-icons/faPlus'
import { faPen as farPen } from '@fortawesome/pro-regular-svg-icons/faPen'
import { faPencil as farPencil } from '@fortawesome/pro-regular-svg-icons/faPencil'

library.add(farArrowRotateLeft, farPen, farPlus, farPencil)

import { faRightLeft as fadRightLeft } from '@fortawesome/pro-duotone-svg-icons/faRightLeft'
import { faHouseMedical as fadHouseMedical } from '@fortawesome/pro-duotone-svg-icons/faHouseMedical'
import { faSpinnerThird as fadSpinnerThird } from '@fortawesome/pro-duotone-svg-icons/faSpinnerThird'
import { faLoader as fadLoader } from '@fortawesome/pro-duotone-svg-icons/faLoader'
import { faPartyHorn as fadPartyHorn } from '@fortawesome/pro-duotone-svg-icons/faPartyHorn'
import { faRadiation as fadRadiation } from '@fortawesome/pro-duotone-svg-icons/faRadiation'

library.add(fadHouseMedical, fadRightLeft, fadSpinnerThird, fadLoader, fadPartyHorn, fadRadiation)

import { faAngleDown as fasAngleDown } from '@fortawesome/pro-solid-svg-icons/faAngleDown'
import { faArrowRightLong as fasArrowRightLong } from '@fortawesome/pro-solid-svg-icons/faArrowRightLong'
import { faAt as fasAt } from '@fortawesome/pro-solid-svg-icons/faAt'
import { faBabyCarriage as fasBabyCarriage } from '@fortawesome/pro-solid-svg-icons/faBabyCarriage'
import { faCheck as fasCheck } from '@fortawesome/pro-solid-svg-icons/faCheck'
import { faCheckCircle as fasCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle'
import { faChevronUp as fasChevronUp } from '@fortawesome/pro-solid-svg-icons/faChevronUp'
import { faCircle as fasCircle } from '@fortawesome/pro-solid-svg-icons/faCircle'
import { faExclamation as fasExclamation } from '@fortawesome/pro-solid-svg-icons/faExclamation'
import { faPencil as fasPencil } from '@fortawesome/pro-solid-svg-icons/faPencil'
import { faPersonSimple as fasPersonSimple } from '@fortawesome/pro-solid-svg-icons/faPersonSimple'
import { faPersonDressSimple as fasPersonDressSimple } from '@fortawesome/pro-solid-svg-icons/faPersonDressSimple'
import { faPhone as fasPhone } from '@fortawesome/pro-solid-svg-icons/faPhone'
import { faSignalWeak as fasSignalWeak } from '@fortawesome/pro-solid-svg-icons/faSignalWeak'
import { faSignalFair as fasSignalFair } from '@fortawesome/pro-solid-svg-icons/faSignalFair'
import { faSignalGood as fasSignalGood } from '@fortawesome/pro-solid-svg-icons/faSignalGood'
import { faStar as fasStar } from '@fortawesome/pro-solid-svg-icons/faStar'
import { faSquare as fasSquare } from '@fortawesome/pro-solid-svg-icons/faSquare'
import { faSquareCheck as fasSquareCheck } from '@fortawesome/pro-solid-svg-icons/faSquareCheck'
import { faTrash as fasTrash } from '@fortawesome/pro-solid-svg-icons/faTrash'
import { faUserNinja as fasUserNinja } from '@fortawesome/pro-solid-svg-icons/faUserNinja'
import { faUserMd as fasUserMd } from '@fortawesome/pro-solid-svg-icons/faUserMd'
import { faXmark as fasXmark } from '@fortawesome/pro-solid-svg-icons/faXmark'

library.add(
  fasAngleDown,
  fasArrowRightLong,
  fasAt,
  fasBabyCarriage,
  fasCheck,
  fasCheckCircle,
  fasChevronUp,
  fasCircle,
  fasExclamation,
  fasPhone,
  fasPencil,
  fasPersonSimple,
  fasPersonDressSimple,
  fasSignalWeak,
  fasSignalFair,
  fasSignalGood,
  fasStar,
  fasSquare,
  fasSquareCheck,
  fasTrash,
  fasUserNinja,
  fasUserMd,
  fasXmark
)

import { faCheck as farCheck } from '@fortawesome/pro-regular-svg-icons/faCheck'
import { faCircle as farCircle } from '@fortawesome/pro-regular-svg-icons/faCircle'
import { faMessages as farMessages } from '@fortawesome/pro-regular-svg-icons/faMessages'
import { faSpinnerThird as farSpinnerThird } from '@fortawesome/pro-regular-svg-icons/faSpinnerThird'
import { faStopwatch as farStopwatch } from '@fortawesome/pro-regular-svg-icons/faStopwatch'
library.add(farCheck, farCircle, farMessages, farSpinnerThird, farStopwatch)

import { faAngleDown as falAngleDown } from '@fortawesome/pro-light-svg-icons/faAngleDown'
import { faAngleUp as falAngleUp } from '@fortawesome/pro-light-svg-icons/faAngleUp'
import { faArrowRotateLeft as falArrowRotateLeft } from '@fortawesome/pro-light-svg-icons/faArrowRotateLeft'
import { faArrowRight as falArrowRight } from '@fortawesome/pro-light-svg-icons/faArrowRight'
import { faAt as falAt } from '@fortawesome/pro-light-svg-icons/faAt'
import { faBadgePercent as falBadgePercent } from '@fortawesome/pro-light-svg-icons/faBadgePercent'
import { faBars as falBars } from '@fortawesome/pro-light-svg-icons/faBars'
import { faBed as falBed } from '@fortawesome/pro-light-svg-icons/faBed'
import { faBell as falBell } from '@fortawesome/pro-light-svg-icons/faBell'
import { faCartShopping as falCartShopping } from '@fortawesome/pro-light-svg-icons/faCartShopping'
import { faCheck as falCheck } from '@fortawesome/pro-light-svg-icons/faCheck'
import { faCheckCircle as falCheckCircle } from '@fortawesome/pro-light-svg-icons/faCheckCircle'
import { faChevronDown as falChevronDown } from '@fortawesome/pro-light-svg-icons/faChevronDown'
import { faChevronLeft as falChevronLeft } from '@fortawesome/pro-light-svg-icons/faChevronLeft'
import { faChevronRight as falChevronRight } from '@fortawesome/pro-light-svg-icons/faChevronRight'
import { faChevronUp as falChevronUp } from '@fortawesome/pro-light-svg-icons/faChevronUp'
import { faCircle as falCircle } from '@fortawesome/pro-light-svg-icons/faCircle'
import { faCircleQuestion as falCircleQuestion } from '@fortawesome/pro-light-svg-icons/faCircleQuestion'
import { faClockRotateLeft as falClockRotateLeft } from '@fortawesome/pro-light-svg-icons/faClockRotateLeft'
import { faComments as falComments } from '@fortawesome/pro-light-svg-icons/faComments'
import { faDownload as falDownload } from '@fortawesome/pro-light-svg-icons/faDownload'
import { faDumbbell as falDumbbell } from '@fortawesome/pro-light-svg-icons/faDumbbell'
import { faEye as falEye } from '@fortawesome/pro-light-svg-icons/faEye'
import { faExclamationCircle as falExclamationCircle } from '@fortawesome/pro-light-svg-icons/faExclamationCircle'
import { faHospitalAlt as falHospitalAlt } from '@fortawesome/pro-light-svg-icons/faHospitalAlt'
import { faListCheck as falListCheck } from '@fortawesome/pro-light-svg-icons/faListCheck'
import { faLockKeyhole as falLockKeyhole } from '@fortawesome/pro-light-svg-icons/faLockKeyhole'
import { faCircleInfo as falCircleInfo } from '@fortawesome/pro-light-svg-icons/faCircleInfo'
import { faFileCheck as falFileCheck } from '@fortawesome/pro-light-svg-icons/faFileCheck'
import { faFilePdf as falFilePdf } from '@fortawesome/pro-light-svg-icons/faFilePdf'
import { faPrint as falPrint } from '@fortawesome/pro-light-svg-icons/faPrint'
import { faSpinnerThird as falSpinnerThird } from '@fortawesome/pro-light-svg-icons/faSpinnerThird'
import { faSquare as falSquare } from '@fortawesome/pro-light-svg-icons/faSquare'
import { faSquareCheck as falSquareCheck } from '@fortawesome/pro-light-svg-icons/faSquareCheck'
import { faTimer as falTimer } from '@fortawesome/pro-light-svg-icons/faTimer'
import { faTrash as falTrash } from '@fortawesome/pro-light-svg-icons/faTrash'
import { faPaperclip as falPaperclip } from '@fortawesome/pro-light-svg-icons/faPaperclip'
import { faPaste as falPaste } from '@fortawesome/pro-light-svg-icons/faPaste'
import { faPencil as falPencil } from '@fortawesome/pro-light-svg-icons/faPencil'
import { faUserGroup as falUserGroup } from '@fortawesome/pro-light-svg-icons/faUserGroup'
import { faUserHeadset as falUserHeadset } from '@fortawesome/pro-light-svg-icons/faUserHeadset'
import { faUserMd as falUserMd } from '@fortawesome/pro-light-svg-icons/faUserMd'
import { faXmark as falXmark } from '@fortawesome/pro-light-svg-icons/faXmark'
import { faRightFromBracket as falRightFromBracket } from '@fortawesome/pro-light-svg-icons/faRightFromBracket'
import { faUpload as falUpload } from '@fortawesome/pro-light-svg-icons/faUpload'
import { faVideo as falVideo } from '@fortawesome/pro-light-svg-icons/faVideo'

library.add(
  falAngleDown,
  falAngleUp,
  falArrowRight,
  falArrowRotateLeft,
  falAt,
  falBadgePercent,
  falBars,
  falBed,
  falBell,
  falCartShopping,
  falCheck,
  falCheckCircle,
  falChevronDown,
  falChevronLeft,
  falChevronRight,
  falChevronUp,
  falCircle,
  falCircleInfo,
  falCircleQuestion,
  falClockRotateLeft,
  falComments,
  falDownload,
  falDumbbell,
  falExclamationCircle,
  falEye,
  falFileCheck,
  falFilePdf,
  falHospitalAlt,
  falListCheck,
  falLockKeyhole,
  falPaperclip,
  falPaste,
  falPencil,
  falPrint,
  falRightFromBracket,
  falSpinnerThird,
  falSquare,
  falSquareCheck,
  falTimer,
  falTrash,
  falUpload,
  falUserGroup,
  falUserHeadset,
  falUserMd,
  falVideo,
  falXmark
)

// Benefits Widget

import { faHospital as falHospital } from '@fortawesome/pro-light-svg-icons/faHospital'
import { faHouseMedical as falHouseMedical } from '@fortawesome/pro-light-svg-icons/faHouseMedical'
import { faHeadSideMedical as falHeadSideMedical } from '@fortawesome/pro-light-svg-icons/faHeadSideMedical'
import { faHeadSideBrain as falHeadSideBrain } from '@fortawesome/pro-light-svg-icons/faHeadSideBrain'
import { faGlobe as falGlobe } from '@fortawesome/pro-light-svg-icons/faGlobe'
import { faKitMedical as falKitMedical } from '@fortawesome/pro-light-svg-icons/faKitMedical'
import { faBedPulse as falBedPulse } from '@fortawesome/pro-light-svg-icons/faBedPulse'
import { faSeedling as falSeedling } from '@fortawesome/pro-light-svg-icons/faSeedling'
import { faGlasses as falGlasses } from '@fortawesome/pro-light-svg-icons/faGlasses'
import { faUserNurse as falUserNurse } from '@fortawesome/pro-light-svg-icons/faUserNurse'
import { faVacuum as falVacuum } from '@fortawesome/pro-light-svg-icons/faVacuum'
import { faHouseHeart as falHouseHeart } from '@fortawesome/pro-light-svg-icons/faHouseHeart'
import { faSpa as falSpa } from '@fortawesome/pro-light-svg-icons/faSpa'
import { faPersonSwimming as falPersonSwimming } from '@fortawesome/pro-light-svg-icons/faPersonSwimming'
import { faHotTubPerson as falHotTubPerson } from '@fortawesome/pro-light-svg-icons/faHotTubPerson'
import { faCoins as falCoins } from '@fortawesome/pro-light-svg-icons/faCoins'
import { faShirt as falShirt } from '@fortawesome/pro-light-svg-icons/faShirt'
import { faBandage as falBandage } from '@fortawesome/pro-light-svg-icons/faBandage'
import { faStethoscope as falStethoscope } from '@fortawesome/pro-light-svg-icons/faStethoscope'
import { faPills as falPills } from '@fortawesome/pro-light-svg-icons/faPills'
import { faUmbrellaSimple as falUmbrellaSimple } from '@fortawesome/pro-light-svg-icons/faUmbrellaSimple'
import { faPersonPregnant as falPersonPregnant } from '@fortawesome/pro-light-svg-icons/faPersonPregnant'
import { faHospitalUser as falHospitalUser } from '@fortawesome/pro-light-svg-icons/faHospitalUser'
import { faSquarePlus as falSquarePlus } from '@fortawesome/pro-light-svg-icons/faSquarePlus'
import { faLifeRing as falLifeRing } from '@fortawesome/pro-light-svg-icons/faLifeRing'
import { faTruckMedical as falTruckMedical } from '@fortawesome/pro-light-svg-icons/faTruckMedical'
import { faHelicopter as falHelicopter } from '@fortawesome/pro-light-svg-icons/faHelicopter'
import { faCarSide as falCarSide } from '@fortawesome/pro-light-svg-icons/faCarSide'
import { faTooth as falTooth } from '@fortawesome/pro-light-svg-icons/faTooth'
import { faSuitcaseMedical as falSuitcaseMedical } from '@fortawesome/pro-light-svg-icons/faSuitcaseMedical'
import { faTeethOpen as falTeethOpen } from '@fortawesome/pro-light-svg-icons/faTeethOpen'
import { faToothbrush as falToothbrush } from '@fortawesome/pro-light-svg-icons/faToothbrush'
import { faFamily as falFamily } from '@fortawesome/pro-light-svg-icons/faFamily'
import { faCandleHolder as falCandleHolder } from '@fortawesome/pro-light-svg-icons/faCandleHolder'
import { faPhone as falPhone } from '@fortawesome/pro-light-svg-icons/faPhone'
import { faPercent as falPercent } from '@fortawesome/pro-light-svg-icons/faPercent'
import { faEnvelopeOpenDollar as falEnvelopeOpenDollar } from '@fortawesome/pro-light-svg-icons/faEnvelopeOpenDollar'
import { faFilesMedical as falFilesMedical } from '@fortawesome/pro-light-svg-icons/faFilesMedical'
import { faNotesMedical as falNotesMedical } from '@fortawesome/pro-light-svg-icons/faNotesMedical'
import { faDna as falDna } from '@fortawesome/pro-light-svg-icons/faDna'
import { faMicroscope as falMicroscope } from '@fortawesome/pro-light-svg-icons/faMicroscope'
import { faUser as falUser } from '@fortawesome/pro-light-svg-icons/faUser'
import { faBaby as falBaby } from '@fortawesome/pro-light-svg-icons/faBaby'
import { faChild as falChild } from '@fortawesome/pro-light-svg-icons/faChild'
import { faCircleDollar as falCircleDollar } from '@fortawesome/pro-light-svg-icons/faCircleDollar'
library.add(
  falHospital,
  falHouseMedical,
  falHeadSideMedical,
  falHeadSideBrain,
  falGlobe,
  falKitMedical,
  falBedPulse,
  falSeedling,
  falGlasses,
  falUserNurse,
  falVacuum,
  falHouseHeart,
  falSpa,
  falPersonSwimming,
  falHotTubPerson,
  falCoins,
  falShirt,
  falBandage,
  falStethoscope,
  falPills,
  falUmbrellaSimple,
  falPersonPregnant,
  falHospitalUser,
  falSquarePlus,
  falLifeRing,
  falTruckMedical,
  falHelicopter,
  falCarSide,
  falTooth,
  falSuitcaseMedical,
  falTeethOpen,
  falToothbrush,
  falFamily,
  falCandleHolder,
  falPhone,
  falPercent,
  falEnvelopeOpenDollar,
  falFilesMedical,
  falNotesMedical,
  falDna,
  falMicroscope,
  falUser,
  falBaby,
  falChild,
  falCircleDollar
)

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default FontAwesomeIcon

export const ART = {
  fad: 'duo',
  far: 'regular',
  fat: 'thin',
  fal: 'light',
  fas: 'solid',
}
